import {
	currentPeriodType,
	getPeriodTypeFromId,
} from "../../period/PeriodType.js";

const defaultPeriodType = currentPeriodType;

/**
 * Todo: Add JSDoc comment
 */
export default function getPeriodSpec({
	periodService,
	makePeriodPopover,
	getPeriod,
	isBimesterEnabled,
}) {
	return {
		type: "period",
		optionalAttributes: {
			shift: 0,
			shiftPeriodType: defaultPeriodType.getId(),
			periodType: defaultPeriodType.getId(),
		},
		getValue: ({ value }) => value?.toSmartString().toString(),
		makePopover: setupPopover({
			makePeriodPopover,
			getPeriod,
			isBimesterEnabled,
		}),
		fetcher: async ({
			shift: shiftString,
			shiftPeriodType: shiftPeriodTypeId,
			periodType: periodTypeId,
		}) => {
			const period = getPeriod();
			const shift = +shiftString;
			const shiftPeriodType = getPeriodTypeFromId(shiftPeriodTypeId);
			const periodType = getPeriodTypeFromId(periodTypeId);

			const value = await periodService.getFiscalYearPeriod({
				period,
				shift,
				shiftPeriodType,
				periodType,
			});

			return {
				value,
				shift,
				shiftPeriodType,
				periodType,
			};
		},
	};
}

function setupPopover({ makePeriodPopover, getPeriod, isBimesterEnabled }) {
	if (!makePeriodPopover) {
		return undefined;
	}
	return ({ updateNodeAttributes, getTriggerItem, content }) => {
		makePeriodPopover({
			getPeriod,
			isBimesterEnabled,
			defaultPeriodType,
			updateNodeAttributes,
			getTriggerItem,
			content,
		});
	};
}
